<template>
  <div class="container--fluid d-flex flex-column flex-md-row overflow-hidden" v-if="item">
    <Navbar/>
    <!--    <v-app-bar max-height="90" height="90" elevation="0" color="transparent">-->
    <!--      <div class="container d-flex pa-0">-->
    <!--        <v-btn @click="$router.back()" icon>-->
    <!--          <v-icon>mdi-arrow-left</v-icon>-->
    <!--        </v-btn>-->
    <!--        <v-spacer></v-spacer>-->
    <!--        <v-btn @click="$store.dispatch('cart/show')" class="mr-0" icon>-->
    <!--          <v-badge :content="`${$store.state.cart.items.length}`" color="red" overlap>-->
    <!--            <v-icon>mdi-cart</v-icon>-->
    <!--          </v-badge>-->
    <!--        </v-btn>-->
    <!--      </div>-->
    <!--    </v-app-bar>-->

    <div class="position-relative">
      <ItemPicturesCarousel :item="item"/>
    </div>

    <v-sheet class="px-6 py-9" style="z-index: 1;box-shadow: 0 0 10px rgba(0, 0, 0, .07)">
      <v-chip class="percent-off px-3 mb-1" color="red" outlined small v-if="discount">{{ discount.percentage }}% off
        <span v-if="discount.end">, ends {{ discount.end | timeago }}</span>
      </v-chip>
      <div class="d-flex justify-space-between align-center">
        <div class="title font-weight-bold text--secondary" v-if="selected.monthly_amount_estimate || selected.monthly_amount">
          <small class="text-strikethrough grey--text" v-if="discount">
            {{ (item.credit_price || item.price) / item.no_of_months | currency }}
          </small>
          {{ (selected.monthly_amount_estimate || selected.monthly_amount) | currency }} / mo
          ({{ selected.no_of_months }} month{{ selected.no_of_months > 1 ? 's' : '' }})
        </div>
        <div class="title font-weight-medium text--secondary" v-else>
          <small class="text-strikethrough grey--text" v-if="discount">{{ item.price | currency }}</small>
          {{ selected.upfront_amount | currency }} outright
        </div>
        <div class="d-flex">
          <v-btn @click="addLike" icon>
            <v-badge :content="`${item.likes}`" color="grey" right>
              <v-icon color="red" v-if="liked">mdi-heart</v-icon>
              <v-icon v-else>mdi-heart-outline</v-icon>
            </v-badge>
          </v-btn>
          <v-btn @click="views = { ...views, reviews: true }" class="ml-1" icon>
            <v-badge :content="`${item.total_ratings}`" color="grey">
              <v-icon>mdi-comment-outline</v-icon>
            </v-badge>
          </v-btn>
        </div>
      </div>
      <div class="blue-grey--text font-weight-bold">{{ item.name }}</div>
      <v-rating :value="itemRating" background-color="orange lighten-3" color="orange" dense readonly size="15"></v-rating>
      <v-divider class="my-4"></v-divider>
      <div class="d-flex align-center justify-space-between mt-3">
        <span class="text--secondary">Buy on Credit</span>
        <v-switch :disabled="!credit" class="ma-0" dense hide-details inset v-model="buy_on_credit"></v-switch>
      </div>
      <v-alert class="text-body-2 ma-0 mt-3" dark dense rounded text type="info" v-if="buy_on_credit">
        Eligibility calculated at checkout
      </v-alert>
      <!-- Size Variation -->
      <template v-if="sizes.length">
        <v-divider class="my-4 fill-width"></v-divider>
        <div class="d-inline-flex align-center">
          <v-radio-group class="ma-0" dense hide-details label="Size" row v-if="sizes && sizes.length" v-model="variations.size">
            <v-radio :key="size" :label="size" :value="size" v-for="size in sizes"></v-radio>
          </v-radio-group>
        </div>
      </template>
      <v-divider class="my-4"></v-divider>
      <div class="d-flex">
        <div class="d-inline-flex align-center">
          <template v-if="item.quantity">
            <v-text-field dense hide-details outlined readonly style="width: 120px" v-model="quantity">
              <v-icon @click="decrementQuantity()" color="red" slot="prepend">mdi-minus</v-icon>
              <v-icon @click="incrementQuantity()" color="green" slot="append-outer">mdi-plus</v-icon>
            </v-text-field>
            <v-btn
              @click="addToCart()" class="ml-2 px-8" color="primary" dark elevation="0"
              v-if="$store.state.merchant.partnership === 1 || !buy_on_credit"
            >
              Add to cart
            </v-btn>
            <v-btn @click="showView('payment')" class="ml-2 px-8" color="primary" dark elevation="0" v-else>
              Credit options
            </v-btn>
          </template>
          <v-chip class="px-5" color="red" dark v-if="!item.quantity">Out of stock</v-chip>
        </div>
      </div>
      <v-divider class="my-4"></v-divider>
      <div>
        <v-tabs v-model="tab">
          <v-tab class="pa-0 mr-5">Description</v-tab>
          <v-tab class="pa-0 mr-5" v-if="$store.getters['merchant/theme'].show_product_comments">Reviews ({{ item.total_ratings }})</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item class="py-6">
            <v-subheader class="px-0 text--secondary" style="height: initial" v-if="!item.description">
              No description
            </v-subheader>
            <div class="body-1 black--text text--lighten-2 pre-wrap" v-html="item.description"></div>
          </v-tab-item>
          <v-tab-item class="py-6" v-if="$store.getters['merchant/theme'].show_product_comments">
            <Reviews :embedded="true" :itemId="item.id" @close="closeReview($event)" v-if="item.id"/>
          </v-tab-item>
        </v-tabs-items>

        <RelatedItems :item="item" class="my-10" v-if="item && item.id"/>
      </div>
    </v-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.more">
      <v-card class="pa-0" elevation="0">
        <v-card-text class="pa-0 pt-3">
          <ItemMore :item="item" @close="views.more = false"/>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" v-model="views.payment">
      <v-sheet class="pa-8">
        <ItemPlans :plans="plans" @select="handlePlanChange($event, true)"/>
      </v-sheet>
    </v-bottom-sheet>

    <v-bottom-sheet inset max-width="500" persistent scrollable v-model="views.reviews">
      <Reviews :itemId="item.id" @close="closeReview($event)"/>
    </v-bottom-sheet>

    <v-snackbar v-model="toast.visible" :color="toast.color || ''" bottom>
      {{ toast.message }}
    </v-snackbar>
  </div>
</template>

<script>
	import ItemMore from "../ItemMore"
	import ItemPicturesCarousel from "../ItemPicturesCarousel"
	import Reviews from "../../Reviews"
	import item from "../../../mixins/item";
	import Navbar from "../../nav/Navbar";
	import RelatedItems from "../RelatedItems";
	import ItemPlans from "../ItemPlans";

	export default {
		name: 'ItemMobile2',
		components: { ItemPlans, RelatedItems, Navbar, ItemMore, ItemPicturesCarousel, Reviews },
		mixins: [item],
		data: () => ({ tab: 0 }),
		created() {
			this.applyWatchers();
			this.handleStateChange();
		},
	}
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  /*.container--fluid {*/
  /*  height: calc((var(--vh, 1vh) * 100));*/
  /*}*/
</style>
